import googleanalyticsIcon from 'assets/webanalyticsproviders/googleanalytics.svg';
import yandexmetrikaIcon from 'assets/webanalyticsproviders/yandexmetrika.svg';
import amocrmIcon from 'assets/webanalyticsproviders/amocrm.svg';
import comagicIcon from 'assets/webanalyticsproviders/comagic.svg';
import customIcon from 'assets/webanalyticsproviders/custom.svg';
import appmetricaIcon from 'assets/webanalyticsproviders/appmetrica.svg';

import appContext from 'legacy/appcontext';

const channelIconMap = {
    googleanalytics: googleanalyticsIcon,
    yandexmetrika: yandexmetrikaIcon,
    amocrm: amocrmIcon,
    comagic: comagicIcon,
    custom: customIcon,
    appmetrica: appmetricaIcon
};

const getWaIconByChannelId = (providerId) => {
    const providers = appContext.waProviders().toJSON();

    const provider = providers.filter(i => i.id === providerId)[0];
    return channelIconMap[provider.name];
};


export {getWaIconByChannelId};
export default channelIconMap;
